import {
    LabelBody,
    LabelHeader4,
    SecondaryButton,
    Spacer,
} from '../../components';
import { useSyncedState } from '../../useSyncedState';
import { Rating } from './Rating';
import { RatingSlider } from './RatingSlider';

type Props = {
    ratings: Rating[];
    onContinue: (ratings: Rating[]) => void;
};

export function Page3({ ratings: initialRatings, onContinue }: Props) {
    const [ratings, setRatings] = useSyncedState(initialRatings);

    if (ratings.length === 0) {
        return (
            <>
                <LabelHeader4>
                    Du mangler at vælge dine livsområder
                </LabelHeader4>
                <LabelBody className="mt-10">
                    For at du kan komme videre med næste del af øvelsen, hvor du
                    skal rate dine livsområder, skal du først gå tilbage og
                    udfylde dem.
                </LabelBody>
                <div className="my-30 space-y-20">
                    <RatingSlider
                        rating={{ name: 'F.eks. familie', rating: 0 }}
                        ratings={[]}
                        onChangeRatings={() => {}}
                        minText={'Mindst vigtig'}
                        maxText={'Mest vigtig'}
                        disabled
                    />
                </div>
                <Spacer />
            </>
        );
    }
    return (
        <>
            <LabelHeader4>Hvad er vigtigt for dig?</LabelHeader4>
            <LabelBody className="mt-10">
                Du skal nu til at rate dine valgte livsområder. 5 er det, der er
                mest vigtig, og 1 er mindst vigtigt. Der er ikke nogen rigtig
                måde at rate noget på - alle dine livsområder må godt være lige
                vigtige, og der må også godt være forskelle. Prøv at glem hvad
                andre måske synes er vigtigt, og fokuser på hvad der betyder
                noget for dig.
            </LabelBody>
            <div className="my-30 space-y-20">
                {ratings.map((rating) => (
                    <RatingSlider
                        key={rating.name}
                        rating={rating}
                        ratings={ratings}
                        onChangeRatings={setRatings}
                        minText={'Mindst vigtig'}
                        maxText={'Mest vigtig'}
                    />
                ))}
            </div>
            <Spacer />
            <SecondaryButton onClick={() => onContinue(ratings)}>
                Fortsæt
            </SecondaryButton>
        </>
    );
}
